import { Label, Typography } from '@musinsa/mds';
import type { FC } from 'react';

const DISPLAY_NAME = 'ProductInformation.ExclusiveGoodsBadge';

interface Props {
  className?: string;
}

export const ExclusiveGoodsBadge: FC<Props> = ({ className }) => (
  <Label variant="grayOpacity" className={className}>
    <Typography size="11">단독</Typography>
  </Label>
);

ExclusiveGoodsBadge.displayName = DISPLAY_NAME;
